export default "__VITE_ASSET__c70ab6bf__"